import api from '../index'

export default {

    /**
     * Show a quote
     * @param billingAccount
     * @param quote
     * @param params
     */
    show(billingAccount, quote, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/quotes/${quote}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update a quote
     * @param billingAccount
     * @param quote
     * @param data
     */
    update(billingAccount, quote, data) {
        return api
            .put(`/billing/billing-accounts/${billingAccount}/quotes/${quote}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete a quote
     * @param billingAccount
     * @param quote
     */
    delete(billingAccount, quote) {
        return api
            .delete(`/billing/billing-accounts/${billingAccount}/quotes/${quote}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Finalize a quote
     * @param billingAccount
     * @param quote
     */
    finalize(billingAccount, quote) {
        return api
            .post(`/billing/billing-accounts/${billingAccount}/quotes/${quote}/finalize`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get the invoice of a quote
     * @param billingAccount
     * @param quote
     * @param params
     */
    getInvoice(billingAccount, quote, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/quotes/${quote}/invoice`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Accept a quote
     * @param billingAccount
     * @param quote
     */
    accept(billingAccount, quote) {
        return api
            .post(`/billing/billing-accounts/${billingAccount}/quotes/${quote}/accept`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Show a quote line
     * @param billingAccount
     * @param quoteLineId
     * @param params
     */
    showLine(billingAccount, quoteLineId, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/quote-lines/${quoteLineId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get lines of a quote
     * @param billingAccount
     * @param quote
     * @param params
     */
    getLines(billingAccount, quote, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/quotes/${quote}/lines`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get grouped lines for a quote
     * @param billingAccount
     * @param quote
     * @param params
     */
    getGroupedLines(billingAccount, quote, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/quotes/${quote}/lines/grouped`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    }

}
